export const toContacts = contacts =>
  contacts.map(contact => ({
    value: contact.id,
    label: contact.firstName + ' ' + contact.lastName
  }))

export const toDealsSelect = deals => {
  return deals.map(deal => {
    return {
      value: deal.id,
      label: deal.name,
      clients: deal.dealCompanies
    }
  })
}

export const toTypesOfWork = typesOfWork => {
  return typesOfWork.map(typeOfWork => {
    return {
      value: typeOfWork.id,
      label: typeOfWork.name
    }
  })
}
